<div>
    <div class="filter" [formGroup]="searchForm">
        <div class="my-2">
            <mat-form-field class="mat-shadow-1 search-form-field form-slim w-100">
                <button matPrefix type="button" matIconButton class="search-button" (click)="this.searchFeatures()">
                    <mat-icon>search</mat-icon>
                </button>
                <input matInput formControlName="search" autocomplete="off" placeholder="Search my data..."
                       (input)="this.searchFeatures()"/>
                <button matSuffix type="button" matIconButton class="close-button" (click)="this.clearText()">
                    <mat-icon>close</mat-icon>
                </button>
            </mat-form-field>
        </div>

        <div class="mat-toolbar-filters">
            <div>
                <mat-label class="mat-font-body-md">Layer</mat-label>
                <mat-form-field class="form-ultra-slim">
                    <mat-select formControlName="layer" [(value)]="this.filterSelectedLayer"
                                (valueChange)="filterLayerFeatures($event)" panelWidth="fit-content">
                        <mat-option class="mat-font-body-sm" value="">All</mat-option>
                        @for (name of this.layersNames; track name) {
                            <mat-option class="mat-font-body-sm" [value]="name">
                                {{ name }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
            <div>
                <mat-label class="mat-font-body-md">Field</mat-label>
                <mat-form-field class="form-ultra-slim">
                    <mat-select formControlName="field" [(value)]="this.filterSelectedField"
                                (valueChange)="filterFieldFeatures($event)" panelWidth="fit-content">
                        <mat-option class="mat-font-body-sm" value="">All</mat-option>
                        @for (property of this.featuresProperties; track property) {
                            <mat-option class="mat-font-body-sm" [value]="property">
                                {{ property }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
    </div>

    <mat-divider class="my-2"></mat-divider>
    <div *ngIf="this.anyFilterActive()" class="count-filtered-layers">{{ this.layers.length }} layer results</div>

    <div
            [class.dragable-container]="!isMultiSelectMode || !this.selectedFeature"
            cdkDropList
            (cdkDropListDropped)="!isMultiSelectMode ? changeUserLayerOrder($event) : null">
        <div *ngFor="let layer of layers" cdkDrag [cdkDragDisabled]="isMultiSelectMode || selectedFeature">
            <div class="drag-placeholder" *cdkDragPlaceholder></div>
            <div [class.selected-layer]="selectedLayers.has(layer)">
                <phoenix-user-layer-data
                        [layer]="layer"
                        [selectedFeature]="this.selectedFeature"
                        [focusedLayer]="focusedLayer"
                        [focusedFeature]="focusedFeature"
                        [layerFeatureFilter]="layerFeatureFilter"
                        [multiSelectMode]="isMultiSelectMode"
                        [selected]="selectedLayers.has(layer)"
                        (onFocusLayer)="onFocusLayer($event)"
                        (selectFeatureEvent)="onSelectedFeature($event)"
                        (retrieveDamageAssessmentEvent)="openDamageAssessmentDialog($event)"
                        (retrievePropertyInformationEvent)="openPropertyInformationDialog($event)"
                        (selectLayer)="isMultiSelectMode ? onSelectedMultiLayer($event) : onSelectedLayer($event)"></phoenix-user-layer-data>
            </div>
        </div>
    </div>

    @if (layers?.length > 1 && !selectedLayer && !selectedFeature) {
        <div class="actions-toolbar my-1 d-flex">
            @if (isMultiSelectMode) {
                <div class="col-md-6 px-1">
                    <button matButton="elevated" color="warn" class="w-100" (click)="deleteSelectedLayers()">
                        <mat-icon>delete</mat-icon>
                        Remove ({{ selectedLayers.size }})
                    </button>
                </div>
                <div [className]="isMultiSelectMode ? 'col-md-6' : 'col-md-12'" class="px-1">
                    <button (click)="toggleMultiSelectMode()" matButton="elevated" class="w-100">
                        Cancel
                    </button>
                </div>
            } @else {
                <div [className]="isMultiSelectMode ? 'col-md-6' : 'col-md-12'" class="px-1">
                    <button (click)="toggleMultiSelectMode()" matButton="elevated" class="w-100">
                        Multiple selection
                    </button>
                </div>
            }
        </div>
    }

</div>
